
import { defineComponent, PropType, ref, onUpdated, computed, Ref } from "vue";
import SortOrderDropDownOption from "./SortOrderDropDownOption.vue";
import { SortOrderOption } from "../models/sortOrderOptions";
import vClickOutside from "click-outside-vue3";

export default defineComponent({
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    SortOrderDropDownOption
  },
  props: {
    dropdownId: {
      type: String,
      required: false,
      default: "sortOrderDropdown"
    },
    label: {
      type: String,
      required: true,
      default: ""
    },
    options: {
      type: Array as PropType<SortOrderOption[]>,
      required: true,
      default: () => []
    }
  },
  setup(props, context) {
    const selectedOption: Ref<SortOrderOption> = ref(null);
    const sortByButton: Ref<HTMLElement | null> = ref(null);
    const sortByPanel: Ref<HTMLElement | null> = ref(null);

    const displayLabel = computed(() => {
      if (selectedOption?.value && selectedOption.value.key !== "score") {
        return selectedOption.value.displayName;
      }
      return props.label;
    });

    onUpdated(() => {
      const opts: SortOrderOption[] = props.options as SortOrderOption[];
      if (!selectedOption.value) {
        selectedOption.value = opts && opts.length > 0 ? opts[0] : null;
      }
    });

    const updateSelectedValue = (newValue: SortOrderOption) => {
      selectedOption.value = newValue;
      context.emit("sortOrderChange", newValue);
      if (sortByButton?.value) {
        sortByButton.value.classList.remove("panelActive");
        sortByButton.value.setAttribute("aria-expanded", "false");
      }

      if (sortByPanel?.value) {
        sortByPanel.value.setAttribute("aria-hidden", "true");
        sortByPanel.value.setAttribute("aria-expanded", "false");
        sortByPanel.value.classList.remove("panelActive");
      }
    };

    const sortByClick = (event) => {
      event.stopPropagation();
      if (sortByButton?.value) {
        if (sortByButton.value.classList.contains("panelActive")) {
          sortByButton.value.classList.remove("panelActive");
          sortByButton.value.setAttribute("aria-expanded", "false");
        } else {
          sortByButton.value.classList.add("panelActive");
          sortByButton.value.setAttribute("aria-expanded", "true");
        }
      }

      if (sortByPanel?.value) {
        if (sortByPanel.value.classList.contains("panelActive")) {
          sortByPanel.value.setAttribute("aria-hidden", "true");
          sortByPanel.value.setAttribute("aria-expanded", "false");
          sortByPanel.value.classList.remove("panelActive");
        } else {
          sortByPanel.value.setAttribute("aria-hidden", "false");
          sortByPanel.value.setAttribute("aria-expanded", "true");
          sortByPanel.value.classList.add("panelActive");
        }
      }
    };

    const clickOutsideSortByPanel = (event) => {
      //   console.log(123);
    };

    return {
      displayLabel,
      selectedOption,
      updateSelectedValue,
      sortByButton,
      sortByPanel,
      sortByClick,
      clickOutsideSortByPanel
    };
  }
});
